export default __webpack_public_path__ + "static/media/Bitmap.178865cb.png";